/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CommesseResponseDTO
 */
export interface CommesseResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof CommesseResponseDTO
     */
    idCommessa?: number;
    /**
     * 
     * @type {string}
     * @memberof CommesseResponseDTO
     */
    descrizione?: string | null;
}

/**
 * Check if a given object implements the CommesseResponseDTO interface.
 */
export function instanceOfCommesseResponseDTO(value: object): value is CommesseResponseDTO {
    return true;
}

export function CommesseResponseDTOFromJSON(json: any): CommesseResponseDTO {
    return CommesseResponseDTOFromJSONTyped(json, false);
}

export function CommesseResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommesseResponseDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'idCommessa': json['idCommessa'] == null ? undefined : json['idCommessa'],
        'descrizione': json['descrizione'] == null ? undefined : json['descrizione'],
    };
}

export function CommesseResponseDTOToJSON(json: any): CommesseResponseDTO {
    return CommesseResponseDTOToJSONTyped(json, false);
}

export function CommesseResponseDTOToJSONTyped(value?: CommesseResponseDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idCommessa': value['idCommessa'],
        'descrizione': value['descrizione'],
    };
}

